import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class UnfocusBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.unfocus;
        this.handler = () => { };
    }
    start() {
        this.plasm.debug(`Behavior ${this.id} started`);
    }
    stop() {
        this.plasm.debug(`Behavior ${this.id} stopped`);
    }
}
export default UnfocusBehavior;
